function initializeCustomScrollbar() {
  if (window.innerWidth <= 1000) return;
  const section = document.querySelector('[data-scroll-thumbnails]');
  const thumb = document.querySelector('[data-scrollbar-thumb]');
  const track = document.querySelector('[data-scrollbar-track]');
  if (!section || !thumb || !track) return;
  const sectionHeight = section.offsetHeight;
  const viewportHeight = window.innerHeight;
  const trackHeight = track.offsetHeight;
  const thumbHeight = Math.max(30, (viewportHeight / sectionHeight) * trackHeight);
  thumb.style.height = thumbHeight + 'px';
  function updateThumbPosition() {
    const scrollTop = window.scrollY;
    const sectionTop = section.offsetTop;
    const scrollInSection = scrollTop - sectionTop;
    const maxScroll = sectionHeight - viewportHeight;
    const scrollPercent = Math.min(1, Math.max(0, scrollInSection / maxScroll));
    const maxThumbTop = trackHeight - thumbHeight;
    thumb.style.top = (scrollPercent * maxThumbTop) + 'px';
  }

  window.addEventListener('scroll', updateThumbPosition);
  updateThumbPosition();
}

document.addEventListener('DOMContentLoaded', function () {
  initializeCustomScrollbar();
});

window.addEventListener('resize', function () {
  initializeCustomScrollbar();
});
